import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { SideNavService } from './side-nav.services';
import { BrokerSettingListComponent } from 'src/app/component/broker-parser/broker-setting-list/broker-setting-list.component';
import { MenuService } from '../menu-service/menu.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { BusinessReportsService } from 'src/app/component/reports/business-reports/services/business-reports.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.css']
})
export class SideNavComponent implements OnInit, OnDestroy {
  user;
  menus;
  selectedMenu;
  // isSubMenu = false;
  isShowSmallScreenMenu = false;
  selectedMenukey;
  isRouterEventsExist = false;

  constructor(
    private sharedDataService: SharedDataService,
    private SideNavService: SideNavService,
    private menuService: MenuService,
    public sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private businessReportsService: BusinessReportsService
  ) { }

  ngOnInit() {
    this.router.events
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((event) => {
      this.isRouterEventsExist = true;
      if (event instanceof NavigationEnd) {
        if (event.url) {
          this.selectMenuDynamically(event.url);
        }
      }
    });
    this.getUser();
    this.getSubMenus();
    this.getSmallScreenMenuState();
    this.getUrlOnPageReload();
  }

  getUrlOnPageReload() {
    if (this.isRouterEventsExist) return;
    if(this.router.url) {
      this.selectMenuDynamically(this.router.url);
    }
  }

  selectMenuDynamically(routeUrl) {
    if (!this.selectedMenu) {
      const url = routeUrl.split("/");
      if (url[1] === "dashboard" || url[1] === "") {
        this.selectedMenu = "dashboard";
      } else {
        this.selectedMenu = `${url[1]}${url[1] === 'planner' && url[2] === 'v2' ? 'v2' : '' }`;
      }
      this.onSelectMenu(this.menus ? this.menus[this.selectedMenu] : null);
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if(this.user.sRoles)
              this.menus = this.menuService.getMenu(this.user.sRoles, this.user);
              else
              this.menus = this.menuService.getMenu(this.user.roles, this.user);
            } else if ((typeof this.user.roles) === 'object') {
              this.menus = this.menuService.getMenu(this.user.roles[0], this.user);
            }

            Object.keys(this.menus).forEach(key => {
              this.menus[key].sanitizedIcon = this.sanitizer.bypassSecurityTrustHtml(this.menus[key].icon);
            });
          }
        }
      });
  }

  sortMethod(a, b) {
    return a.value.position > b.value.position ? 1 : -1;
  }

  onSelectMenu(menu) {
    if (menu && menu.key === 'reports-pro') {
      this.businessReportsService.savedRange = null;
    }
    this.selectedMenu = menu;
    this.sharedDataService.saveSubMenus(menu ? menu : null);
  }

  getSubMenus() {
    this.sharedDataService
      .getSubMenus()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(menu => {
        if (menu && this.selectedMenu) {
          if (this.selectedMenu.key !== menu.key) {
            this.selectedMenu = menu;
          }
        }
      });
  }

  onSelectMenuSmallScreen(menu) {
    if (menu && menu.key === 'reports-pro') {
      this.businessReportsService.savedRange = null;
    }
    this.selectedMenu = menu;
    this.sharedDataService.saveSubMenus(menu ? menu : null);
    if (this.selectedMenukey === menu.key) {
      this.selectedMenukey = '';
    } else {
      this.selectedMenukey = menu.key;
    }
    this.sharedDataService.setSmallScreenMenuState(false);
  }

  getSmallScreenMenuState() {
    this.sharedDataService
      .getSmallScreenMenuState()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        this.isShowSmallScreenMenu = data;
      });
  }

  closeSmallScreenMenu() {
    this.sharedDataService.setSmallScreenMenuState(false);
  }

  setMenuCss(evt) {
    return 'bg-nav-light text-nav-light';
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (location.href) {
      let currentUrl = location.href.replace('http://','');
      currentUrl = currentUrl.replace('https://','');
      const url = currentUrl.split("/");
      if (url[1] === "dashboard" || url[1] === "") {
        this.selectedMenu = "dashboard";
      } else {
        this.selectedMenu = url[1];
      }
      this.onSelectMenu(this.menus ? this.menus[this.selectedMenu] : null);
    }
  }

  ngOnDestroy(): void {
  }
}
